import { FormErrorIcon as FormErrorIconComponent } from '@chakra-ui/form-control';

export const FormErrorIcon = FormErrorIconComponent;
